import {useMemo} from "react";
import i18n from "../i18n";

// Public pages take their language from `?lang=` instead of the organizer's app language,
// so they read their copy through a translator fixed to that language.
export const usePublicPageLabels = <K extends string>(
    prefix: string,
    keys: readonly K[],
    language: string
): Record<K, string> => useMemo(() => {
    const t = i18n.getFixedT(language);
    return Object.fromEntries(keys.map(key => [key, t(`${prefix}.${key}`)])) as Record<K, string>;
}, [prefix, keys, language]);
